<script lang="ts">
    import ClickAction from '~/components/jet/action/ClickAction.svelte';
    import EllipseLockup from '@amp/web-app-components/src/components/lockups/EllipseLockup/EllipseLockup.svelte';
    import WorkFallback from '~/components/jet/Artwork/fallbacks/classical-works-circle.svelte';
    import { onMount, createEventDispatcher } from 'svelte';
    import { loggerFor } from '@amp/web-apps-logger';

    const log = loggerFor('<EllipseLockup />');
    const dispatch = createEventDispatcher();

    export let item;
    export let displayText: boolean = true;
    export let useDefaultContainerStyles: boolean = true;

    $: artwork = item.artwork;
    $: headline = item.headline;
    $: title = item.title;
    $: subtitles = item.subtitle ? [item.subtitle] : [];
    $: clickAction = item.segue;
    $: isWorkType = item.type === 'work';
    let ellipseComponent: EllipseLockup;

    const getOffset = () => {
        if (!ellipseComponent) {
            return 0;
        }

        const ellipseText = ellipseComponent.getTextContainer();

        if (!ellipseText) return 0;

        const offsetHeight = ellipseText.offsetHeight;
        const marginTop = window.getComputedStyle(ellipseText).marginTop;
        const marginTopNumber = parseInt(marginTop, 10);
        const totalOffset = (offsetHeight + marginTopNumber) / 2;

        return !isNaN(totalOffset) ? totalOffset : 0;
    };

    onMount(() => {
        dispatch('mount', {
            offset: getOffset(),
            resizeCB: getOffset,
        });
    });
</script>

<div class="ellipse-lockup-wrapper" class:has-custom-fallback={isWorkType}>
    <ClickAction action={clickAction}>
        <EllipseLockup
            bind:this={ellipseComponent}
            {title}
            {displayText}
            {artwork}
            {subtitles}
            {useDefaultContainerStyles}
            caption={headline}
            alt=""
            customFallback={isWorkType ? WorkFallback : null}
        >
            <!-- <svelte:fragment slot="favorited-badge">
                <FavoriteBadge {inFavorites} />
            </svelte:fragment> -->
        </EllipseLockup>
    </ClickAction>
    <!-- TODO: rdar://135641537 ([Classical on Web] UI - Contextual Menu Support) -->
    <!-- <amp-contextual-menu-button bind:this={contextMenuEle} {config} /> -->
</div>

<style lang="scss">
    .ellipse-lockup-wrapper {
        --linkHoverTextDecoration: none;

        :global(a) {
            display: block; // Display focus ring
        }

        :global(.text-container) {
            margin-top: 6px;
        }
    }

    .has-custom-fallback {
        :global(.artwork-fallback svg) {
            width: inherit;
            height: inherit;
        }
    }
</style>
